import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import Wrapper from "components/LayoutFront/Wrapper";
import Block from "components/templatesComponents/Block";
import CountCard from "components/templatesComponents/CountCard";
import PageTitle from "components/templatesComponents/PageTitle";
import useGetCounterInfos from "hooks/counter.hook";
import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";

const jsonCache =
  typeof localStorage !== "undefined" && localStorage.getItem("compteur_FI")
    ? JSON.parse(localStorage.getItem("compteur_FI"))
    : {};

const Counter = (props) => {
  const { page } = props;
  const { title, shortDescription, contents } = page;
  const { firstDynamicPart, secondDynamicPart } = contents;

  const { data: counterInfos = jsonCache, isLoading } = useGetCounterInfos({
    enabled: Boolean(process.env.counter_url && process.env.counter_secret && process.env.counter_restart_time),
    refetchInterval: process.env.counter_restart_time * 60 * 1000,
  });

  const counterInformations = useMemo(() => {
    return (
      Object.keys(counterInfos)
        ?.filter((info) => !process.env.counter_hidden_informations.includes(info))
        ?.map((key) => ({
          name: key,
          number: counterInfos[key],
        })) || []
    );
  }, [counterInfos]);

  useEffect(() => {
    if (typeof localStorage !== "undefined" && Object.keys(counterInfos).length > 0) {
      localStorage.setItem("compteur_FI", JSON.stringify(counterInfos));
    }
  }, [counterInfos]);

  return (
    <Wrapper>
      <Block>
        <PageTitle>{title}</PageTitle>
      </Block>
      {shortDescription && <Block>{shortDescription}</Block>}
      {firstDynamicPart}
      <Grid
        container
        spacing={3}
        sx={{
          justifyContent: "center",
          mb: 2,
          px: { xs: 2, lg: 0 },
          "& .fr-h5": { mt: 2 },
        }}
      >
        {isLoading && <p className="fr-h5">Chargement des données...</p>}
        {!isLoading &&
          (counterInformations.length > 0 ? (
            counterInformations.map((info) => <CountCard information={info} key={`counter-${info.name}`} />)
          ) : (
            <Box sx={{ mt: 2, textAlign: "center" }}>
              <p className="fr-h6">Le compteur France identité est actuellement indisponible...</p>
              <p className="fr-h6">Désolé pour la gêne occasionnée</p>
            </Box>
          ))}
      </Grid>
      {secondDynamicPart}
    </Wrapper>
  );
};

Counter.propTypes = {
  page: PropTypes.shape().isRequired,
};

export default Counter;
